import { toKebabCase } from './string.helper';
export function createElement(tag, attributes = {}, appendTo) {
    const el = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => el.setAttribute(toKebabCase(key), value));
    appendTo?.appendChild(el);
    return el;
}
